import { INITIAL_PAYMENT_STEPS_COUNT } from '../../../../../constants/newbuildingMortgage';

export const getInitialPaymentStep = (price: number): number => {
  return Math.round(price / INITIAL_PAYMENT_STEPS_COUNT);
};
